import { useState } from "react";

import homeLogo1 from "../../public/mac1.png";
import homeLogo2 from "../../public/mac2.png";
import homeLogo3 from "../../public/mac3.png";
import arrow from "../../public/arrow1.png";

const HomeImageLogoMobile = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const logos = [homeLogo1, homeLogo2];

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % logos.length);
  };

  return (
    <div className="flex flex-col items-center  mb-8 mt-4 ">
      <div className="w-[190px] sm:w-[250px] lg:w-[250px] h-full flex items-center justify-center overflow-hidden">
        <img
          src={homeLogo2}
          alt="logo"
          className="object-cover w-full h-full"
        />
      </div>

      {/* <div className="flex mt-2">
        <button onClick={handleNext} className="rounded-full p-2 ">
          <img
            src={arrow}
            className="h-[20px] w-[20px] filter invert"
            alt="arrow"
          />
        </button>
      </div> */}
    </div>
  );
};

export default HomeImageLogoMobile;
